module.exports = __webpack_public_path__ + "images/zaimer-c2836d0f.png";